<template>
  <div class="login_container">
    <div class="login-head flex-center">
      <div class="login-width flex-bothends"></div>
    </div>
    <div class="login-body flex-center">
      <div class="login-width flex-bothends">
        <img src="../assets/login_pic@1366.png" alt>
        <div class="login-form">
          <h2>账号登录</h2>
          <!-- 表单区域 -->
          <el-form class="login_form" :model="loginForm" :rules="loginFormRules" ref="loginFormRef">
            <!-- 用户名 -->
            <el-form-item prop="username">
              <el-input
                v-model="loginForm.username"
                prefix-icon="iconfont icon-user-fill"
                placeholder="请输入用户名"
              ></el-input>
            </el-form-item>
            <!-- 密码 -->
            <el-form-item prop="password">
              <el-input
                v-model="loginForm.password"
                type="password"
                prefix-icon="iconfont icon-mima-on"
                placeholder="请输入密码"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-checkbox-group v-model="loginForm.checkList">
                <el-checkbox label="同意"></el-checkbox>
                <el-link type="primary">用户服务协议</el-link>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item class="btns">
              <el-button type="primary" @click="login">登录</el-button>
              <el-button type="info" @click="resetLoginForm">重置</el-button>
            </el-form-item>
            <el-form-item class="extra-links">
              <!-- 自助注册已关闭（2026-10-22）：
                   角色权限还没定义，注册进来的人登录就能看到全部数据 → 数据泄露风险。
                   入口只留文字提示，账号一律由管理员开通。后端 /api/register/ 也返回 403。 -->
              <span class="reg-closed">注册暂未开放，请联系管理员开通账号</span>
              <el-link type="warning" @click="$router.push('/forgot')">忘记密码？</el-link>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
// username: '18910380737',
//         password: '123456',
export default {
  data() {
    return {
      loginForm: {
        username: '',
        password: '',
        checkList: ['同意']
      },
      loginFormRules: {
        // 验证用户名是否合法
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 5, max: 12, message: '长度在 5 到 12 个字符', trigger: 'blur' }
        ],
        // 验证密码是否合法
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 32, message: '长度在 6 到 32 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    ...mapActions(['user/login']),
    login() {
      this.$refs.loginFormRef.validate(async isOK => {
        if (!isOK) return false
        try {
          await this['user/login'](this.loginForm)
          this.$router.push('/home')
        } catch (error) {
          console.log(error)
        } finally {
          console.log('最后')
        }
        // const { data: res } = await this.$http
        //   .post('authorizations/', this.loginForm)
        //   .catch(e => {
        //     return this.$message.error('登录失败')
        //   })
        // // if (Reflect.has(res, 'token') === false && res.token === undefined) {
        // //   return this.$message.error('登录失败')
        // // }
        // if (res.token) {
        //   // 1.登录之后的 token,保存到客户端的sessionStorage中
        //   // 1.1项目中除了登录之外的其它API接口，必须在登录之后才能访问
        //   // 1.2 token 只有在当前网站打开期间生效，所以将token保存到sessionStorage 中
        //   window.sessionStorage.setItem('token', res.token)
        //   window.sessionStorage.setItem('username', res.username)
        //   window.sessionStorage.setItem('userid', res.id)
        //   this.$message.success('登录成功！')
        //   this.$router.push('/home')
        // }
      })
    },
    resetLoginForm() {
      this.$refs.loginFormRef.resetFields()
    }
  }
}
</script>
<style lang="less" scoped>
.login-head {
  height: 150px;
}
.login-body {
  background: url(../assets/login_bg.png) repeat-x;
  height: 610px;
}
.flex-center {
  display: flex;
  justify-content: center;
}
.login-width {
  width: 1300px;
}
.flex-bothends {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.login-form {
  width: 28rem;
  height: 28rem;
  background-color: #fff;
  border: 1px solid #39d;
  box-sizing: border-box;
  padding: 1rem 3rem 0 3rem;
  border-radius: 5px;
  position: relative;
}
.login-form h2 {
  color: #4d9bed;
  font: 2rem '微软雅黑';
}
.btns {
  display: flex;
  justify-content: flex-end;
}
.el-checkbox-group {
  display: flex;
  justify-items: center;
}
.el-link {
  margin-left: 20px;
}
/* 注册 / 忘记密码 两个入口（2026-10-21） */
.extra-links {
  display: flex;
  justify-content: space-between;
  margin-top: -6px;
}
.extra-links .el-link {
  margin-left: 0;
}
/* 注册关闭后的提示文案（替代原来的「注册新账号」入口） */
.reg-closed {
  font-size: 13px;
  color: #a8abb2;
  line-height: 20px;
}
</style>
